/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateCardSkinRequest} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/create_card_skin.pb'
import {CreateCardSkinResponse} from '@cash-web/protos/squareup/cash/whimsicard/api/v1/create_card_skin.pb'


export const createCardSkin = (request: CreateCardSkinRequest, options?: CashRequestOptions) => post<CreateCardSkinRequest, CreateCardSkinResponse>("/2.0/cash/create-card-skin", request, {...options, rejectOnError: true })